/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TechnicalVisitInconsistenciesAliases {
  ACTION_POSTPONE = 'action-postpone',
  ATTACHMENTS_LIST = 'attachments-list',
  AUTOCOMPLETE_MENU_MOBILE = 'autocomplete-menu-mobile',
  AVATAR = 'avatar',
  BREADCRUMB_ACCREDITATION = 'breadcrumb-accreditation',
  CARD_APPOINTMENTS = ' card-appointments',
  CARD_INCONSISTENCY = 'card-inconsistency',
  CARD_POSTPONE = 'card-postpone',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_REQUESTED_DATE = 'contextual-bar-requested-date',
  DATE_FIELD_0 = 'date-field-0',
  DECK_0 = 'deck-0',
  DECK_INCONSISTENCY = 'deck-inconsistency',
  FETCH_ATTACHMENT_LIST = 'fetch-attachment-list',
  FETCH_FORM = 'fetch-form',
  FETCH_INCONSISTENCY = 'fetch-inconsistency',
  FETCH_MENUS_MOBILE = 'fetch-menus-mobile',
  FETCH_REQUESTED_DATE = 'fetch-requested-date',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_ACTION_PERFORMED = 'field-action-performed',
  FIELD_ATTACHMENT_LIST = 'field-attachment-list',
  FIELD_DEADLINE = 'field-deadline',
  FIELD_DETAILING = 'field-detailing',
  FIELD_INCONSISTENCY = 'field-inconsistency',
  FIELD_RESPONSE_DATE = 'field-response-date',
  FIELD_STATUS = 'field-status',
  FIELD_STATUS_INCONSISTENCY = 'field-status-inconsistency',
  FIELD_UPLOADER = 'field-uploader',
  FILE_UPLOADER = 'file-uploader',
  FORM_DATA = 'form-data',
  FORM_MENU_MOBILE = 'form-menu-mobile',
  FORM_POSTPONE = 'form-postpone',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  MAPPER_0 = 'mapper-0',
  MAPPER_ATTACHMENT = 'mapper-attachment',
  MAPPER_INCONSISTENCIES = 'mapper-inconsistencies',
  MODAL_REFUSE = 'modal-refuse',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_APPOINTMENT_DETAILS = 'panel-appointment-details',
  PANEL_CARD = 'panel-card',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_MODAL = 'panel-modal',
  PANEL_REQUESTED_DATE = 'panel-requested-date',
  PANEL_SIDEBAR = 'panel-sidebar',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_AREA_1 = 'text-area-1',
  TEXT_DETAILING = 'text-detailing',
  TEXT_INCONSISTENCY = 'text-inconsistency',
}
export { TechnicalVisitInconsistenciesAliases };
